export default "__VITE_ASSET__D9MKKx2U__"